import climateDataClient from './climateDataClient'

export default climateDataClient
